'use strict';
const angular = require('angular');

export class guestInfoComponent {
  /*@ngInject*/
  constructor(Auth, HistoryService, dialogs, prompt, PiperGuestService) {
    this.Auth = Auth;
    this.HistoryService = HistoryService;
    this.PiperGuestService = PiperGuestService;
    this.dialogs = dialogs;
    this.prompt = prompt;

    this.mapEventIcon = {
      created: 'glyphicon-asterisk',

      edited: 'glyphicon-pencil',
      deleted: 'glyphicon-trash',

      approved: 'glyphicon-ok',
      blocked: 'glyphicon-ban-circle',
      arrived: 'glyphicon-flag'
    };

    this.mapEventClass = {
      created: 'success',
      blocked: 'danger',
      deleted: 'danger',
      approved: 'success',
      arrived: 'success'
    };

    this.events = [];
  }

  getUserShort(user) {
    try {
      return (user) ? user.firstName + " " + user.lastName[0] + "." : "unknown";
    } catch(e) {
      return "unknown";
    }
  }

  $onInit() {
    this.guest = this.resolve.config.guest;

    this.title = (this.guest.isBusiness) ? this.guest.business : this.guest.firstName + " " + this.guest.lastName;

    this.HistoryService.getByEntity({id: this.guest._id}, data => {

      var events = [];

      data.forEach(history => {

        var badgeClass = this.mapEventClass[history.actionType] || "info";
        var badgeIconClass = this.mapEventIcon[history.actionType];

        events.push({
          badgeClass,
          badgeIconClass,
          title: history.action,
          dataAfter: history.dataAfter,
          content: (typeof history.actionMeta == 'string') ? history.actionMeta : '',
          creationDate: history.meta.creationDate,
          creationUser: history.meta.creationUser
        });

      });

      // newest history on top
      this.events = events.reverse();
    });
  };

  ok() {
    this.close({$value: ''});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  addNote() {
    this.prompt({
      title: 'Add Note',
      message: 'Add your note below',
      input: true,
      label: '',
      value: ''
    }).then(note => {

      let noteObj = {
        type: 'host',
        note: note
      };

      this.PiperGuestService.patch({id: this.guest._id}, [
        { "op": "add", "path": "/notes/-", "value": noteObj },
      ], data => {
        this.guest.notes.push(noteObj);
      });
    });
  }

  deleteNote(idx) {
    var dlg = this.dialogs.confirm("Delete Note?", "Do you really want to delete this note?<br/><br/>" + this.guest.notes[idx].note);
    dlg.result.then(() => {
      this.PiperGuestService.patch({id: this.guest._id}, [
        { "op": "remove", "path": "/notes/"+idx },
      ], data => {
        this.guest.notes.splice(idx,1);
      });
    },() => {
    });
  }

  getNoteType(type) {
    switch(type) {
      case 'propertyManagement':
        return "Property Management";
        break;
      case 'security':
        return "Gate";
        break;
      case 'host':
        return "Host";
        break;
      default:
        return "Other"
    }
  }

  getTextHtml(text) {
    return (text) ? text.replace(/(?:\r\n|\r|\n)/g, '<br />') : "";
  }

}

export default angular.module('conduuApp.guestInfoComponent', [])
  .component('guestInfoComponent', {
    template: require('./guest-info.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: guestInfoComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/piper-guest-info/guest-info.component.js